import { IconChevronRight, List, ListItem } from '@spotify-internal/encore-web';

import styles from 'components/TopicList/TopicList.module.scss';

interface TopicListProps {
  topics: Array<{ title: string; value: string }>;
  onClickFunction: (key: string) => any;
}

const TopicList = ({ topics, onClickFunction }: TopicListProps): JSX.Element => {
  return (
    <List className={styles.topicContainer} data-testid="topic-container">
      {topics.map(topic => (
        <ListItem key={topic.value} className={styles.topic}>
          <a
            className={styles.topicLink}
            onClick={e => {
              e.preventDefault();
              onClickFunction(topic.value);
            }}
            href={`#${topic.value}`}
            data-testid={topic.value}
          >
            {topic.title}
            <div className={styles.topicChevron}>
              <IconChevronRight className="rtl-flip" aria-hidden="true" focusable="false" iconSize={24} />
            </div>
          </a>
        </ListItem>
      ))}
    </List>
  );
};

export default TopicList;
